import * as Inovx from '@shared';
import type { IHomeKnowledgeBook } from '../constants/interfaces';

const UrlUtilities = Inovx.Shared.Common.UrlUtilities;

const HomeKnowledgeBookServices = Object.assign({}, Inovx.Shared.Flux.BaseService, {
    getRecentOpenedKnowledgeBooks(): Promise<IHomeKnowledgeBook[]> {
        const url = UrlUtilities.getApiUrl() + '/FacilityApi/api/KnowledgeBook/Recent?limit=10';
        return new Promise<IHomeKnowledgeBook[]>((resolve, reject) => {
            this.get(
                url,
                null,
                (data: IHomeKnowledgeBook[]) => resolve(data),
                (error: any) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },

    getFavoriteKnowledgeBooks(): Promise<IHomeKnowledgeBook[]> {
        const url = UrlUtilities.getApiUrl() + '/FacilityApi/api/KnowledgeBook/Favorites?limit=10';
        return new Promise<IHomeKnowledgeBook[]>((resolve, reject) => {
            this.get(
                url,
                null,
                (data: IHomeKnowledgeBook[]) => resolve(data),
                (error: any) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
});

export default HomeKnowledgeBookServices;
